<template>
  <Teleport :to="`#main-header-container`">
    <div :id="`shortcode-next-matches-${id}`" v-if="window.size.mobile && !window.PHP.bot && matches.length > 2">
      <div class="border-y pb-2 border-zt-light -mx-4 relative">
        <div :id="`swiper-shortcode-mecze-${id}`" class="swiper pt-2">
          <div :id="`swiper-shortcode-mecze-wrapper-${id}`" class="swiper-wrapper pl-[6px] flex gap-x-[6px]">
            <a v-for="match in matches" :href="`/wyniki-pilka-nozna/porownanie-druzyn/${match.localteam_queryname}/${match.visitorteam_queryname}/`"
               data-count-click="Shortcode NAJBLIŻSZE MECZE w Typach Redaktorów - MECZE" data-count-click-category="football"
               class="no-default-style zt-hover swiper-slide gap-x-1 border rounded-zt border-zt-more w-[104px] flex items-center last:mr-5">
              <span class="text-[10px] text-center w-fit pl-1 leading-[17px] font-normal text-zt-more">{{ getMatchDate(match.date) }}</span>
              <div class="flex flex-col gap-y-[2px] items-start pr-[6px]">
                <div class="flex gap-x-1 max-h-[15px]">
                  <TeamImg class="!w-[10px] !h-[10px] inline-block translate-y-[2px]" :team="getTeamForImg(match, 'local')"/>
                  <div class="text-[10px] max-h-[15px] font-normal text-ellipsis break-all line-clamp-1"> {{ match.localteam_short_name !== '' ? match.localteam_short_name : match.localteam_name }} </div>
                </div>
                <div class="flex gap-x-1 max-h-[15px]">
                  <TeamImg class="!w-[10px] !h-[10px] inline-block translate-y-[2px]" :team="getTeamForImg(match, 'visitor')"/>
                  <div class="text-[10px] max-h-[15px] font-normal text-ellipsis break-all line-clamp-1"> {{ match.visitorteam_short_name !== '' ? match.visitorteam_short_name : match.visitorteam_name }} </div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div :class="`swiper-scrollbar-shortcode-mecze-${id}`"
           class="swiper-scrollbar !h-[2px] bg-[#3a4b6480] !cursor-default"></div>
    </div>
  </Teleport>
</template>

<script>
import Swiper from 'swiper';
import { FreeMode, Scrollbar } from 'swiper/modules';
import TeamImg from './football_stats/blocks/TeamImg.vue';

export default {
  name: 'MatchTimetableForPosts',
  components: {TeamImg},
  inject: ['WP'],
  data() {
    this.uniqId = `table-${Math.floor(Math.random() * 1000000)}`;
    return {
      matches: [],
      id: this.uniqId,
      isUnderHTag: false,
    }
  },
  mounted() {
    axios.post(this.WP.ajaxUrl, {
      endpoint: 'api_get_highlighted_matches',
    }).then(response => {
      this.matches = response.data.data;
      setTimeout(() => {
        new Swiper(`#swiper-shortcode-mecze-${this.id}`, {
          modules: [Scrollbar, FreeMode],
          slidesPerView: 'auto',
          resistanceRatio: 0,
          centeredSlides: window.size.mobile,
          centeredSlidesBounds: window.size.mobile,
          freeMode: {
            enabled: true,
            minimumVelocity: 0.01,
            momentum: true,
            momentumBounce: false,
            momentumRatio: 0.7,
            momentumVelocityRatio: 0.5,
            sticky: false,
          },
          scrollbar: {
            el: `.swiper-scrollbar-shortcode-mecze-${this.id}`,
            hide: true,
          },
          spaceBetween: 6,
        });
        document.querySelector(`#swiper-shortcode-mecze-wrapper-${this.id}`)?.classList.remove('gap-x-[6px]');
      }, 100);
    });
  },
  methods: {
    getTeamForImg(match, type) {
      return {
        query_name: type === 'local' ? match.localteam_queryname : match.visitorteam_queryname,
        team_id: type === 'local' ? match.localteam_id : match.visitorteam_id,
        name: type === 'local' ? match.localteam_name : match.visitorteam_name
      }
    },
    getMatchDate(date) {
      date = DateTime.fromSQL(date);
      const today = DateTime.now();
      const dayDiff = Math.round(today.diff(date, 'days').days);
      if (dayDiff === 0) {
        return `${date.toFormat(`HH:mm`)}`;
      }
      if (dayDiff === -1) {
        return `Jutro`;
      }
      return date.toFormat('dd.MM');
    }
  }
}
</script>
